<template>
   <div class="section section-gallery" id="section-gallery" v-if="gallery != 0">
        <div class="container">
            <div class="section-title">
                <h5>{{gallery.upper_title}}</h5>
                <h2>{{gallery.title}}</h2>
            </div>
        </div>
        <div class="container">
            <div class="gal-items" v-if="!respond">
                <div class="gal-item" :class="col.size.value" v-for="(col, index) in gallery.gallery_grid"  @click.prevent="initGalleryModal(index)">
                    <svg-icon icon-class="resize" className="icon-resize"/>
                    <img :src="col.img" alt="">
                </div>
            </div>
        </div>
        <div class="gal-mobile-carousel">
            <swiper :options="swiperOption" ref="galMobileCarousel">
                <swiper-slide v-for="(slide, index) in gallery.gallery_grid" :key="index">
                    <img :src="slide.img" alt="">
                </swiper-slide>
            </swiper>
        </div>
        <div class="swiper-controls gal-mobile-swiper-controls">
            <div class="gal-mobile-swiper-btn-prev slider-btn"><svg-icon icon-class="left-arrow" className="icon-left-arrow"/></div>
            <div class="gal-mobile-swiper-btn-next slider-btn"><svg-icon icon-class="right-arrow" className="icon-right-arrow"/></div>
        </div>
        <transition name="fade">
            <!-- модалка планировки -->
            <modal name="gallery-modal-carousel" :width="GalModalWidth" :height="GalModalHeight" id="gallery-modal-carousel" :transition="transitionName" @opened="galleryModalOpened" @closed="galleryModalClosed" @before-close="beforeGalleryModalClosed">
                <div class="modal-content">
                    <button class="btn-close-gallery-modal" @click="closeGalleryModal"><svg-icon icon-class="close" className="icon-close"/></button>
                    <div class="gallery-carousel">
                        <flickity ref="flickity" :options="flickityOptions">
                            <div class="carousel-cell" v-for="(slide, index) in gallery.gallery_grid" :key="index">
                                <img :src="slide.img" alt="">
                            </div>
                        </flickity>
                        <div class="flickity-controls">
                            <div class="gal-btn-prev slider-btn" @click="prevSlide"><svg-icon icon-class="left-arrow" className="icon-left-arrow"/></div>
                            <div class="gal-btn-next slider-btn" @click="nextSlide"><svg-icon icon-class="right-arrow" className="icon-right-arrow"/></div>
                        </div>
                    </div>
                </div>
            </modal>
            <!-- end -->
        </transition>
   </div>
</template>

<script>
    import Flickity from 'vue-flickity';
    
    export default {
        name: 'Gallery',
        props: ['respond'],
        components: {
            Flickity
        },
        data () {
            return {
                modalData: 0,
                transitionName: 'pop-out',
                flickityOptions: {
                    initialIndex: 0,
                    fade: true,
                    prevNextButtons: false,
                    pageDots: false,
                    wrapAround: true,
                },
                swiperOption: {
                    speed: 600,
                    observer: true,
                    observeParents: true,
                    effect: 'fade',
                    loop: true,
                    navigation: {
						nextEl: '.gal-mobile-swiper-btn-next',
						prevEl: '.gal-mobile-swiper-btn-prev',
					},
                },
                GalModalWidth: 1100,
                GalModalHeight: 680,
            }
        },
        computed: {
            gallery () {
                return this.$store.state.gallery
            },
        },
        methods: {
            initGalleryModal(index) {
                this.modalData = index;
                this.$modal.show('gallery-modal-carousel');
            },
            galleryModalOpened() {
                window.body.addClass('overlay-open');
                this.$refs.flickity.select(this.modalData, true, true);
            },
            galleryModalClosed() {
                 window.body.removeClass('overlay-open');
            },
            beforeGalleryModalClosed() {
                $('.gallery-modal-carousel').fadeOut(300);
            },
            closeGalleryModal() {
                this.$modal.hide('gallery-modal-carousel');
            },
            prevSlide() {
                this.$refs.flickity.previous();
            },
            nextSlide() {
                this.$refs.flickity.next();
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/gallery/gallery.scss';
    @import '@/styles/components/gallery/media/media-tablet-pro.scss';
    @import '@/styles/components/animation/animation-gallery.scss';
</style>